import {alpha, PaletteMode} from "@mui/material";

export const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
        mode,
        // palette values for light mode
        primary: {
            main: '#5084b6',
            ...(mode === 'dark' && {
                main: '#5084b6',
                contrastText: "#f5f7f8"
            }),
        },
        secondary: {
            main: '#89c9f4',
        },
        appBar: {
            light: '#729bc2',
            main: '#5084b6',
            dark: '#385b7e',
            contrastText: "#f5f7f8",
            ...(mode === 'dark' && {
                light: '#192333',
                main: '#060c18',
                dark: '#060c18',
                contrastText: "#f5f7f8"
            }),
        },
        background: {
            default: '#f5f7f8',
            paper: '#fdfdfd',
            menu: '#f5f7f8',
            input: '#f5f7f8',
            ...(mode === 'dark' && {
                default: '#2d3747',
                paper: '#192027',
                menu: '#192027',
                input: '#171721'
            }),
        },
        text: {
            primary: '#3d4651',
            secondary: '#596877',
            ...(mode === 'dark' && {
                primary: '#efefef',
                secondary: '#c5c5c5',
            }),
        },
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                enableColorOnDark: true,
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    color: '#f5f7f8',
                    '&.Mui-selected': {
                        color: '#f5f7f8',
                    },
                },

            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    ...(mode === 'dark' && {
                        backgroundColor: "#171721",
                    }),
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: `url('/assets/layout_back.svg') repeat-x 1% 70% fixed #f5f7f8`,
                    ...(mode === "dark" && {
                        background: `url('/assets/layout_back.svg') repeat-x 1% 70% fixed #2d3747`,
                    }),
                    backgroundSize: "80vh",
                    "div ::-webkit-scrollbar": {
                        width: '0.6em',
                        height: '0.6em',
                    },
                    "div ::-webkit-scrollbar-track": {
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        borderRadius: '0.6em',
                    },
                    "div ::-webkit-scrollbar-thumb": {
                        backgroundColor: alpha("#89c9f4", 0.8),
                        borderRadius: '0.6em',
                    },
                    "div ::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#89c9f4",
                    },
                },
            },
        },
    },
    typography: {
        fontFamily: [
            'Open Sans',
            'Roboto',
            'Open Sans Semi Bold',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        h1: {
            fontFamily: [
                '"Fredericka the Great"',
                'cursive',
            ].join(','),
        },
        h2: {
            fontFamily: [
                '"Fredericka the Great"',
                'cursive',
            ].join(','),
        },
        h3: {
            fontFamily: [
                '"Fredericka the Great"',
                'cursive',
            ].join(','),
        },
        h4: {
            fontFamily: [
                'Open Sans Semi Bold',
                'cursive',
            ].join(','),
        },
        h5: {
            fontFamily: [
                'Open Sans Semi Bold',
                'cursive',
            ].join(','),
        },
        h6: {
            fontFamily: [
                'Open Sans Semi Bold',
                'cursive',
            ].join(','),
        },
        subtitle1: {
            fontFamily: [
                'Open Sans',
                'cursive',
            ].join(','),
        },
        subtitle2: {
            fontFamily: [
                'Open Sans',
                'cursive',
            ].join(','),
        },
        body1: {
            fontFamily: [
                'Open Sans',
                'cursive',
            ].join(','),
            fontSize: 15
        },
        body2: {
            fontFamily: [
                'Open Sans',
                'cursive',
            ].join(','),
        },
        button: {
            fontFamily: [
                'Open Sans',
                'cursive',
            ].join(','),
            fontSize: 16
        },
        input: {
            fontFamily: [
                'Roboto',
                'cursive',
            ].join(','),
            fontWeight: 500,
        }
    },
});
